import { Inject, Component, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ToastrComponent } from '../toastr/toastr.component';

@Component({
    selector: 'app-confirm-component',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmComponent {

    basicForm: UntypedFormGroup;
    loading = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private toastr: ToastrComponent,
        public dialogRef: MatDialogRef<ConfirmComponent>) {
        this.createForm();
    }

    createForm() {
        this.basicForm = this.fb.group({
            mensagem: ['']
        });
    }

    handleAcao() {

        if (this.data.component === 'estimativa') {

            let statusId = 0;
            statusId = this.data.acao === 'aprovar' ? 2 : 3;

            const mensagem = this.basicForm.value.mensagem;

            if (mensagem !== '') {
                if (mensagem.length > 500) {
                    this.toastr.mostrarMensagem('aviso', 'Atenção', 'Comentário excede o máximo de caracteres permitido: 500');
                    return;
                }
            }

            if (this.data.acao === 'reprovar') {
                if (mensagem === '') {
                    this.toastr.mostrarMensagem('aviso', 'Atenção', 'Comentário necessário em caso de reprovação');
                    return;
                }
            }

            this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Estimativa aprovada com sucesso')

            this.dialogRef.close({ statusId, mensagem });
        }
    }
}
